export default __webpack_public_path__ + "static/media/05-small.6e541431.jpg";